var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products"},[_c('top-banner',{attrs:{"title":"Projects","subtitle":"We stick to good discipline of software engineering to accomplish better project success.","topimage":_vm.image}}),_c('navbar'),_c('ProjectsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }